module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-12.5b33ae88.svg";